module.exports = __webpack_public_path__ + "assets/img/604c08084b244e19a091aa85cde9810c.svg";